import { type EventNotificationTriggerFilters } from '@reliance/types/filters/EventNotificationTriggerFilters';
import {
  type ActionCreate,
  type ActionUpdate,
  type Trigger,
  type TriggerCreate,
  type TriggerUpdate,
} from '@reliance/types/models/EventNotification';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService, type ApiSuccessResponse } from '../types/ApiService';

export const eventNotification = (api: ApiService) => ({
  trigger: {
    index: (
      params?: Partial<EventNotificationTriggerFilters>,
    ): Promise<PaginatedResponse<Trigger> | ApiSuccessResponse<Trigger[]>> => {
      return api.get('/event-notification/trigger', { params });
    },

    get: (id: number): Promise<Trigger> => {
      return api.get(`/event-notification/trigger/${id}`);
    },

    post: (data: TriggerCreate): Promise<ApiSuccessResponse<void>> => {
      return api.post('/event-notification/trigger', { trigger: data });
    },

    put: (
      id: number,
      data: TriggerUpdate,
    ): Promise<ApiSuccessResponse<void>> => {
      return api.put(`/event-notification/trigger/${id}`, { updates: data });
    },

    delete: (id: number): Promise<ApiSuccessResponse<void>> => {
      return api.delete(`/event-notification/trigger/${id}`);
    },
  },
  action: {
    post: (
      triggerId: number,
      data: ActionCreate,
    ): Promise<ApiSuccessResponse<void>> => {
      return api.post(`/event-notification/trigger/${triggerId}/action`, {
        action: data,
      });
    },

    put: (
      triggerId: number,
      actionId: number,
      data: ActionUpdate,
    ): Promise<ApiSuccessResponse<void>> => {
      return api.post(
        `/event-notification/trigger/${triggerId}/action/${actionId}`,
        { updates: data },
      );
    },

    delete: (
      triggerId: number,
      actionId: number,
    ): Promise<ApiSuccessResponse<void>> => {
      return api.delete(
        `/event-notification/trigger/${triggerId}/action/${actionId}`,
      );
    },
  },
});
